<template>
    <div class="row justify-content-center">
        <loading :loading="loading"></loading>
        <div class="col-11 col-xs-11 col-md-6">
            <div class="u-form u-mt1">
                <h3>Edit Message</h3>
                <ion-label>Provide a title for your message</ion-label>
                <ion-input placeholder="Title" type="text" shape="round" expand="full" :value="title" v-on:ionInput="setTitle($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>


                <ion-label>When would you like to send the message?</ion-label>
                <ion-datetime
                    display-format="DD MMM YYYY"
                    picker-format="DD MMM YYYY"
                    :min="today"
                    max="2080-12-31"
                    placeholder="Select a date"
                    :value="send_at"
                    expand="full"
                    v-on:ionFocus="setDefaultDate($event)"
                    v-on:ionChange="setDate($event)"></ion-datetime>

                <div v-if="message.type =='audio'">
                    <audio controls style="width:100%;">
                        <source :src="message.path" :type="message.mime">
                        Your browser does not support the audio tag.
                    </audio>
                </div>
                <div v-else-if="message.type =='video'">
                    <video controls style="width:100%;">
                        <source :src="message.path" :type="message.mime">
                        Your browser does not support the video tag.
                    </video>
                </div>
                <div v-else-if="message.type =='image'">
                    <ion-img :src="message.path"></ion-img>
                </div>
                <div v-else>
                    <ion-label>Your Message</ion-label>
                    <ion-textarea placeholder="Your Message" :value="text" rows="6" type="text" shape="round" expand="full" v-on:ionInput="setText($event)" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-textarea>
                </div>
                <ion-label>Who do you want to send this to?</ion-label>
                <div v-for="(recipient, i) in recipientList" v-bind:key="i">
                    {{recipient.name}} - {{recipient.email}}
                </div>
                <ion-select multiple="true" placeholder="Select Recipients" v-if="hasContacts" v-on:ionChange="setRecipients($event)">
                    <ion-select-option v-for="contact in contacts" :value="contact.id" v-bind:key="contact.id" :selected-text="contact.name" :selected="inRecipients(contact.id)">
                        {{contact.name}} - {{contact.email}}
                    </ion-select-option>
                    <ion-select-option :value="0" selected-text="New Recipient" :selected="inRecipients('0')">
                        Add a new recipient
                    </ion-select-option>
                </ion-select>
                <div v-if="!hasContacts || newContact">
                    <ion-label>Add a new recipient</ion-label>
                    <ion-input placeholder="Name" type="text" shape="round" v-on:ionInput="setRecipientName($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                    <ion-input placeholder="Email Address" type="email" shape="round" v-on:ionInput="setRecipientEmail($event)" expand="full" style='background:var(--ion-color-light); border-radius: 20px; margin-bottom: 12px; text-align: left; --padding-start: 20px'></ion-input>
                </div>

                <ion-button shape="round" expand="full" v-on:click="saveMessage()" :disabled="!canSend">Save Message</ion-button>
                <ion-button shape="round" expand="full" v-on:click="deleteMessage()" style="--background : var(--ion-color-danger);">Delete Message</ion-button>
            </div>
            <div class="row justify-content-center">
                <div class="col-11 col-xs-11 col-md-6">
                    <div class="router-nav u-mt2 u-mb2">
                        <ion-button shape="round" expand="full" v-on:click="back()">Return</ion-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

import Loading from '@/components/Loading.vue';
import {auth} from '@/mixins/auth';
import {userdetails} from '@/mixins/userdetails';
import {alerts} from '@/mixins/alerts';

export default {
    name: 'edit',
    mounted : function () {
        this.showLoading();
        // this.getMessage();
        this.getContacts();
    },
    components : {
        Loading
    },
    data : function () {
        return {
            title        : '',
            text         : '',
            message      : {
                path : '',
                mime : '',
                type : 'text'
            },
            contacts     : [],
            recipients   : [],
            newRecipient : {
                name : '',
                email : ''
            },
            send_at : moment().endOf('year').add(1, 'day').format('YYYY-MM-DD'),
            newContact : false,
            loading  : false
        }
    },
    computed : {
        recipientList : function () {
            let list = this.recipients;
            let recipients = _.filter(this.contacts, function (contact) {
                return list.indexOf(contact.id.toString()) != -1 || list.indexOf(parseInt(contact.id)) != -1 ;
            });
            if (list.indexOf('0') != -1 || list.indexOf(0) != -1) {
                recipients.push({
                    id : 0,
                    name : 'New Recipient',
                    email : this.newRecipient.email
                });
            }
            return recipients;
        },
        today : function () {
            return moment().add(1, 'day').format('YYYY-MM-DD');
        },
        hasContacts : function () {
            return _.size(this.contacts) > 0;
        },
        canSend : function () {
            if (_.size(this.recipients) == 0) {
                if (this.newRecipient.name == '' || this.newRecipient.email == '') {
                    return false;
                }
            } else {
                var newRecipient = _.find(this.recipients, function (recipient) {
                    return recipient == 0;
                });
                if (newRecipient) {
                    if (this.newRecipient.name == '' || this.newRecipient.email == '') {
                        return false;
                    }
                }
            }
            return true;
        }
    },
    mixins : [auth, userdetails, alerts],
    methods : {
        inRecipients : function (id) {
            var intId = parseInt(id);
            if (this.recipients.indexOf(intId) != -1) {
                return true;
            }
            var strId = id.toString();
            if (this.recipients.indexOf(strId) != -1) {
                return true;
            }
            return false;
        },
        showLoading : function () {
            this.loading = true;
        },
        hideLoading : function () {
            this.loading = false;
        },
        back : function () {
            this.$router.push({name : 'allmessages'});
        },
        getContacts : function () {
            let self = this;
            this.axios.get(this.api + 'contacts')
                .then(response => {
                    self.contacts = response.data;
                    self.getMessage();
                })
                .catch(error => {
                    console.error('Could not get contacts', error);
                    self.hideLoading();
                })
        },
        getMessage : function () {
            let self = this;
            this.axios.get(this.api + 'messages/' +  this.$route.params.id)
                .then(response => {
                    let message = response.data
                    self.message = message;
                    self.title = message.title;
                    self.text = message.message;
                    self.send_at = moment(message.send_at).format('YYYY-MM-DD');
                    let recipients = _.map(message.recipients, 'id');
                    self.recipients = recipients;
                    self.hideLoading();
                })
                .catch(error => {
                    console.error('Could not get message', error);
                    self.hideLoading();
                });
        },
        setTitle : function (event) {
            this.title = event.target.value;
        },
        setText : function (event) {
            this.text = event.target.value;
        },
        setDate : function (event) {
            if (event.detail.value.year) {
                var date = moment();
                date.year(event.detail.value.year.value);
                date.month(event.detail.value.month.value);
                date.date(event.detail.value.day.value);
                this.send_at = date.format('YYYY-MM-DD');
                return;
            }
            var send_at = moment(event.detail.value);
            if (send_at.isValid()) {
                this.send_at = send_at.format('YYYY-MM-DD');
            }
        },
        setRecipientName : function (event) {
            this.newRecipient.name = event.target.value;
        },
        setRecipientEmail : function (event) {
            this.newRecipient.email = event.target.value;
        },
        setRecipients : function (event) {
            // console.log('setting recipients', event);
            let self = this;
            this.newContact = false;
            var recipients = event.detail.value;
            if (!Array.isArray(recipients)) {
                recipients = recipients.split(',');
            }
            this.recipients = recipients;
            _.each(recipients, function (r) {
                if (r == 0) {
                    self.newContact = true;
                }
            });
        },
        saveMessage : function () {
            // @todo validate!
            let self = this;

            let recipients = [];
            if (!Array.isArray(this.recipients)) {
                this.recipients = [this.recipients];
            }
            _.each(this.recipients, function (recipient) {
                if (recipient != 0) {
                    var contact = _.find(self.contacts, function (contact) {
                        return contact.id == recipient;
                    });
                    if (contact) {
                        recipients.push({
                            id    : contact.id,
                            name  : contact.name,
                            email : contact.email
                        });
                    }
                }
            });
            if (this.newRecipient.name != '' && this.newRecipient.email != '') {
                recipients.push(this.newRecipient);
            }
            //
            if (_.size(recipients) == 0) {
                this.showError('You did not select any recipients');
                return;
            }
            let params = {
                title      : this.title,
                message    : this.text,
                send_at    : this.send_at,
                recipients : recipients
            }
            this.axios.put(this.api + 'messages/' + self.$route.params.id, params) // eslint-disable-next-line
                .then(response => {
                    self.showSuccess('The message was updated', function () {
                        self.$router.push({name:  'allmessages'});
                    });
                })
                .catch(error => {
                    console.error('error editing message', error);
                    self.showError('We could not send that message.  Please check the information you provided and try again');
                });
        },
        deleteMessage : function () {
            let self = this;
            return this.$ionic.alertController
                .create({
                    cssClass : 'danger',
                    header: 'Are you sure?',
                    message: 'Please confirm that you want to delete this message. If you delete it, it will not be sent and cannot be viewed.',
                    buttons: [{
                        text: 'Cancel',
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {
                            console.debug('Cancelled');
                        }
                    }, {
                        text: 'Delete',
                        handler: () => {
                            self.axios.delete(self.api + 'messages/' + self.$route.params.id) // eslint-disable-next-line
                                .then(response => {
                                    self.showSuccess('The message was deleted', function () {
                                        self.$router.push({name:  'allmessages'});
                                    });
                                })
                                .catch(error => {
                                    console.error('error removing message', error);
                                })
                        },
                    },
                ],
                })
                .then(a => a.present());
            // confirm with warning
            // post
        },
    }
}
</script>
